
import { set, sub, formatDistanceToNow } from 'date-fns';
const initialState = {
  ip: "52.230.13.131",
};
export default function serverIP (state = initialState, action)  {
  switch (action.type) {
    case 'START': {
      return {
        ...state,
        ip: "52.230.13.131"
      };
    }
    default:
      return state;
  }
};

